import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export function transformAvailableFiltersForAnalytics(availableFilters) {
  var appliedFilters = availableFilters.map(function (availableFilter, index) {
    return _objectSpread(_objectSpread({}, availableFilter), {}, {
      index: index
    });
  }).filter(function (filterWithIndex) {
    return filterWithIndex.isChecked;
  });
  return {
    applied: appliedFilters.map(function (appliedFilter) {
      return {
        id: appliedFilter.id,
        source: appliedFilter.filterSource,
        index: appliedFilter.index
      };
    }),
    recommendedIds: availableFilters.map(function (appliedFilter) {
      return {
        id: appliedFilter.id,
        source: appliedFilter.filterSource
      };
    })
  };
}
export var transformFiltersForAnalytics = function transformFiltersForAnalytics(filters) {
  var filtersForAnalytics = {};
  filters.map(function (filter) {
    filtersForAnalytics = _objectSpread(_objectSpread({}, filtersForAnalytics), {}, _defineProperty({}, filter['@type'], transformAvailableFiltersForAnalytics(filter.store.availableFilters)));
  });
  return filtersForAnalytics;
};